import { render, staticRenderFns } from "./UserPianziList.vue?vue&type=template&id=48cce897&"
import script from "./UserPianziList.vue?vue&type=script&lang=js&"
export * from "./UserPianziList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports